import React from 'react';

import PromotionBanner from 'components/shop/MobilePlans/components/PromotionBanner';
import { useMobilePlansContent } from 'components/shop/MobilePlans/providers';
import {
  RelatedOfferDetails,
  SelectedPlan,
} from 'components/shop/MobilePlans/typings/plans';
import GenericErrorBanner from '../../../../../GenericErrorBanner';
import AddRelatedOfferStep from '../AddRelatedOfferStep';
import AddCompanionsDescription from './components/AddCompanionsDescription';

interface AddCompanionsStepProps {
  selectedPlan: SelectedPlan;
  companionPlan: RelatedOfferDetails;
  isAddingBundles: boolean;
  onNext(): void;
  onSkip(): void;
}

const STEP_TITLE = 'Add companion plans?';
const REGION_ID = 'addCompanionPlansActionLayer';
const TRACKING_EVENT_NAME = 'Add Companion Plans Action Layer';

const AddCompanionsStep = ({
  selectedPlan,
  companionPlan,
  isAddingBundles,
  onNext,
  onSkip,
}: AddCompanionsStepProps) => {
  const { actionLayerContent } = useMobilePlansContent();
  const { name, price } = companionPlan;
  const { description } = actionLayerContent?.companionSelection || {};
  if (!price?.basePrice) {
    return <GenericErrorBanner />;
  }

  return (
    <AddRelatedOfferStep
      regionId={REGION_ID}
      eventName={TRACKING_EVENT_NAME}
      isAddingBundles={isAddingBundles}
      description={
        description ? (
          <AddCompanionsDescription
            title={STEP_TITLE}
            template={description}
            variables={{
              leaderPlanName: selectedPlan.planName,
              companionPlanName: name,
              companionPlanPrice: price.basePrice,
            }}
          />
        ) : null
      }
      title={<PromotionBanner title={STEP_TITLE} />}
      onNext={onNext}
      onSkip={onSkip}
    />
  );
};

export default AddCompanionsStep;
